__turbopack_context__.v({
  "activeDot": "HomepageBannerCarousel-module-scss-module__zNhvTq__activeDot",
  "banner": "HomepageBannerCarousel-module-scss-module__zNhvTq__banner",
  "bannerWrapper": "HomepageBannerCarousel-module-scss-module__zNhvTq__bannerWrapper",
  "dotsContainer": "HomepageBannerCarousel-module-scss-module__zNhvTq__dotsContainer",
  "homepageCarouselContainer": "HomepageBannerCarousel-module-scss-module__zNhvTq__homepageCarouselContainer",
  "iconButtonContainer": "HomepageBannerCarousel-module-scss-module__zNhvTq__iconButtonContainer",
  "inactiveDot": "HomepageBannerCarousel-module-scss-module__zNhvTq__inactiveDot",
});
